module.exports = __webpack_public_path__ + "static/media/ET070 new.6fe137ea.jpg";